import AbstractController from '../src/services/ControllersRepository/AbstractController';
import UsersProfile from '../views/users/UsersProfile';

export default class Profile extends AbstractController {
    protected controllerName = 'Profile';

    protected availableActions = ['profile'];
    protected actionsComponents = {
        profile: UsersProfile
    };
}
